module.exports = __webpack_public_path__ + "img/home-rugby-icon-white.e619f80e.png";